import deepEqual from 'fast-deep-equal';
/**
 * Given two objects, arrays, or primitives, performs a deep equality check.
 */
export function isEqual(arr1, arr2) {
    return deepEqual(arr1, arr2);
}
//# sourceMappingURL=isEqual.js.map